import * as React from 'react';
import cn from 'classnames';
import styles from './styles.module.css';

interface WithNestedLinkProps {
  link: string;
  WrappedComponent: React.ReactElement;
}

export const withNestedLink = (
  link: string,
  WrappedComponent: React.ReactElement,
): React.ReactElement => {
  const children = [
    <a href={link} className={cn(styles.overlay)} key='link'/>,
    <span className={cn(styles.inner)} key='inner'>
      {WrappedComponent.props.children}
    </span>
  ];

  return React.cloneElement(WrappedComponent, {
    className: cn(WrappedComponent.props.className, styles.block),
    children,
  });
};
